import template from './task-detail.html';
import './task-detail.scss';

let taskDetailComponent = {
  template,
  bindings: {
    task: '<'
  },
};

export default taskDetailComponent;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/task-detail.component.js